// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** The general modal styling is in modals.css in
 * the css components folder. This file contains styling only for 
 * the enrollment request AND some styling common to both the 
 * enrollment request modal and approvals modal */

/* background styling for each item in the enrollment request and approvals list */

.modal .requestsList {
  height: 40vh;
  margin-right: 24px; /* We're off by 6 pixels somewhere. */
  overflow-y: scroll;
}

.modal .requestsList::-webkit-scrollbar-corner {
  /*
     * background-image: url(resources/corner.png);
     * background-repeat: no-repeat;
     * */
  background-color: #e5e5e5;
}

.modal .requestContainer {
  background-color: white;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  margin-left: 15px;
}

.modal .requestContainer + .requestContainer {
  margin-top: 1rem;
}

/**** Enrollment request container ****/
/* Name of the user who's asking for enrollment */
.enrollmentRequestContainer .meta > .title {
  font-size: 16px;
  font-weight: bold;
}

.requestContainer .row {
  width: 100%;
}

/* Make the details in a column by default */
.enrollmentRequestContainer .meta {
  display: flex;
  flex-direction: column;
  line-height: 1.7rem;
}

/* The meta details should be in bold */
.enrollmentRequestContainer .assignmentName .title,
.enrollmentRequestContainer .startDate .title,
.enrollmentRequestContainer .endDate .title,
.enrollmentRequestContainer .location .title {
  font-weight: bold;
}

.enrollmentRequestContainer .assignmentName,
.enrollmentRequestContainer .dateContainer,
.enrollmentRequestContainer .location {
  margin-top: -0.2rem;
}

.enrollmentRequestContainer .requestedDate {
  font-style: italic;
  margin-bottom: 0.5rem;
}

/* Start/end date should be in a row */
.enrollmentRequestContainer .dateContainer {
  display: flex;
  flex-direction: row;
}

/* End date should be visually separated from the start date */
.enrollmentRequestContainer .endDate {
  margin-left: 5rem;
}

/* approve/deny buttons */
.enrollmentRequestContainer .actions {
  align-items: center;
}

.enrollmentRequestContainer .actions .spinner {
  margin: 0px auto;
}

.enrollmentRequestContainer .deny {
  background: none;
  border: none;
  font-size: 16px;
  margin: 0.75rem 3rem 0rem;
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/users/enrollmentRequestsModal.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD,kFAAkF;;AAElF;EACE,YAAY;EACZ,kBAAkB,EAAE,qCAAqC;EACzD,kBAAkB;AACpB;;AAEA;EACE;;;QAGM;EACN,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC,iDAAiD;AACjD;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;;;;EAIE,iBAAiB;AACnB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,0BAA0B;AAC5B","sourcesContent":["/** The general modal styling is in modals.css in\n * the css components folder. This file contains styling only for \n * the enrollment request AND some styling common to both the \n * enrollment request modal and approvals modal */\n\n/* background styling for each item in the enrollment request and approvals list */\n\n.modal .requestsList {\n  height: 40vh;\n  margin-right: 24px; /* We're off by 6 pixels somewhere. */\n  overflow-y: scroll;\n}\n\n.modal .requestsList::-webkit-scrollbar-corner {\n  /*\n     * background-image: url(resources/corner.png);\n     * background-repeat: no-repeat;\n     * */\n  background-color: #e5e5e5;\n}\n\n.modal .requestContainer {\n  background-color: white;\n  padding-left: 2rem;\n  padding-right: 2rem;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  margin-left: 15px;\n}\n\n.modal .requestContainer + .requestContainer {\n  margin-top: 1rem;\n}\n\n/**** Enrollment request container ****/\n/* Name of the user who's asking for enrollment */\n.enrollmentRequestContainer .meta > .title {\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.requestContainer .row {\n  width: 100%;\n}\n\n/* Make the details in a column by default */\n.enrollmentRequestContainer .meta {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.7rem;\n}\n\n/* The meta details should be in bold */\n.enrollmentRequestContainer .assignmentName .title,\n.enrollmentRequestContainer .startDate .title,\n.enrollmentRequestContainer .endDate .title,\n.enrollmentRequestContainer .location .title {\n  font-weight: bold;\n}\n\n.enrollmentRequestContainer .assignmentName,\n.enrollmentRequestContainer .dateContainer,\n.enrollmentRequestContainer .location {\n  margin-top: -0.2rem;\n}\n\n.enrollmentRequestContainer .requestedDate {\n  font-style: italic;\n  margin-bottom: 0.5rem;\n}\n\n/* Start/end date should be in a row */\n.enrollmentRequestContainer .dateContainer {\n  display: flex;\n  flex-direction: row;\n}\n\n/* End date should be visually separated from the start date */\n.enrollmentRequestContainer .endDate {\n  margin-left: 5rem;\n}\n\n/* approve/deny buttons */\n.enrollmentRequestContainer .actions {\n  align-items: center;\n}\n\n.enrollmentRequestContainer .actions .spinner {\n  margin: 0px auto;\n}\n\n.enrollmentRequestContainer .deny {\n  background: none;\n  border: none;\n  font-size: 16px;\n  margin: 0.75rem 3rem 0rem;\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
